import {
    
   getCaseById,
   saveCase
} from "@/api/views/caselibrary";

import {
  uploadsFile,
} from "@/api/views/expInfo";

export default {
    data() {
      return {
        // 上传图片地址
        uploadsFile: uploadsFile,
         // 附件列表
        fileList: [],
        caseId: "",
        caseInfo: {
          loading:true,
          name: '',
          author: '',
          company: '',
          industry: '',
          course: '',
          knowledgePoints: ''
        },
        
      };
    },
    created() {
      this.getCaseData();
    },
    methods: {

      beforeUpload(file){

        const allowedSuffixes = ["doc", "docx", "pdf"];
        const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
        if (!allowedSuffixes.includes(fileSuffix)) {
          this.$message.error("上传文件只能是docx、doc、pdf 格式！");
          return false;
        }
        return true;

      },
            // 附件上传成功
          uploadFileSuccess(res, info) {

            //this.form.video = res.path;
            let tmp = {
              name: info.name,
              url: res.path
            }
             // 深拷贝 tmp，避免框架或库的副作用
             tmp = JSON.parse(JSON.stringify(tmp));

             
            console.log("上传成功: ", JSON.stringify(tmp, null, 2));
            this.fileList.push(tmp);

            console.log("全部附件: ", JSON.stringify( this.fileList, null, 2));
        },
        // 视频上传失败
        uploadFileError() {
            this.$message.error("上传失败");
        },
        getCaseData(){
            this.caseId =  Number(this.$router.currentRoute.query.caseID);
            let params = {};
            params.case_id =  this.caseId;

            console.log(params)
            getCaseById(params).then(result => {
                console.log(this.caseInfo)
                this.caseInfo.name=result.data.CaseName;
                this.caseInfo.author=result.data.CaseAuthor;
                this.caseInfo.company=result.data.CompanyName;
                this.caseInfo.industry=result.data.Industry;
                this.caseInfo.course=result.data.Courses;
                this.caseInfo.knowledgePoints=result.data.CaseKnowledgePoints;

                if(result.data.files!==null){

                  try{

                    const filesArray = JSON.parse(result.data.files);
                    this.fileList = filesArray; // 将解析后的数组赋值给 fileList
  
                  }catch{
                    this.fileList=[];
                  }
                }
               

                this.caseInfo.loading=false;
            });

        },
        async  saveCase() {
        // 这里可以添加保存案例信息到服务器的逻辑
          console.log(this.fileList);
        let params = {};
        params.state=0;
        params.case_id = this.caseId;
        params.CaseName=this.caseInfo.name||'';
        params.CaseAuthor=this.caseInfo.author||'';
        params.CompanyName=this.caseInfo.company||'';
        params.Industry=this.caseInfo.industry||'';
        params.ApplicableCourses=this.caseInfo.course||'';
        params.CaseKnowledgePoints=this.caseInfo.knowledgePoints||'';
        params.files= JSON.stringify(this.fileList);
        console.log(  params.files);
        saveCase(params).then(result => {
            if(result.code==1){
                this.$message.success(result.msg);
                this.$router.push({
                    path: "/manager/CaseList",
                });

            }else{
                this.$message.error(result.msg);

            }
      
        });




      },
      cancelEditor(){
        const self = this;
        self.$router.push({
            path: "/manager/CaseList",
        });

      }
    }
  };